<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('expenseCategories') }}</h2>
			</div>
			<!-- Table ExpenseCategories -->
			<ja-expense-categories-table
				v-if="showExpenseCategoriesTable && expenseCategoriesData"
				:data="expenseCategoriesData"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-expense-categories-table>
			<!-- Edit Category -->
			<ja-expense-categories-edit
				v-if="!showExpenseCategoriesTable"
				:expense-category-data="dataEdit"
				@cancel="handleCancel"
				@saveExpenseCategory="handleSaveExpenseCategory"
			></ja-expense-categories-edit>
		</div>
	</div>
</template>
<script>
import ExpenseCategoriesEdit from './ExpenseCategoriesEdit.vue';
import ExpenseCategoriesTable from './ExpenseCategoriesTable.vue';
import ExpenseCategoriesService from '@/services/cms/ExpenseCategoriesService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaExpenseCategoriesTable: ExpenseCategoriesTable,
		jaExpenseCategoriesEdit: ExpenseCategoriesEdit
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showExpenseCategoriesTable: true,
			expenseCategoriesData: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showExpenseCategoriesTable = true;
			this.getExpenseCategories();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showExpenseCategoriesTable = true;
			} else {
				this.showExpenseCategoriesTable = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacility != null) {
			this.$store.commit('setLoading', true);
			this.getExpenseCategories();
		}
	},
	methods: {
		async getExpenseCategories() {
			const data = await ExpenseCategoriesService.getAll(
				this.selectedFacilityId
			);
			data.forEach(bucket => {
				bucket.cmsExpenseCategories.sort((a, b) => (a.name < b.name ? -1 : 1));
			});
			this.expenseCategoriesData = data.sort((a, b) =>
				a.name < b.name ? -1 : 1
			);
			this.$store.commit('setLoading', false);
		},
		async handleEditRow(rowData) {
			this.$store.commit('setLoading', true);
			const data = await ExpenseCategoriesService.getById(
				rowData.expenseCategory_ID
			);
			if (
				data.cmsExpenseSubCategories &&
				data.cmsExpenseSubCategories.length > 0
			) {
				data.cmsExpenseSubCategories.forEach(sub => {
					if (sub.tab == null) {
						sub.tab = { name: '' };
					}
				});
			}
			data.systemName = rowData.displayName;
			this.dataEdit = data;
			this.showExpenseCategoriesTable = false;
			this.$store.commit('setIsReturnOption', false);
			this.$store.commit('setLoading', false);
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await ExpenseCategoriesService.deleteById(rowData.expenseCategory_ID);
			this.getExpenseCategories();
		},
		async handleSaveExpenseCategory(expenseCategory) {
			this.$store.commit('setLoading', true);
			await ExpenseCategoriesService.update(expenseCategory);
			this.$store.commit('setLoading', false);
			this.showExpenseCategoriesTable = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getExpenseCategories();
			this.showExpenseCategoriesTable = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
